var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.637,
    height: 62.637,
    viewBox: "0 0 62.637 62.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pen-tool",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M62.1,16.108,46.531.537a1.835,1.835,0,0,0-2.6,0l-8.03,8.03a1.835,1.835,0,0,0,0,2.6l.795.795-21,10.5a1.835,1.835,0,0,0-.883.96L.14,60.1l-.006.016c-.019.047-.035.095-.05.142a1.9,1.9,0,0,0-.069.339,1.823,1.823,0,0,0,.381,1.333l.033.041a1.832,1.832,0,0,0,1.756.628c.047-.009.093-.021.14-.034l.029-.007a1.832,1.832,0,0,0,.183-.064L39.221,47.825a1.835,1.835,0,0,0,.96-.883l10.5-21,.795.795a1.835,1.835,0,0,0,2.6,0L62.1,18.7A1.835,1.835,0,0,0,62.1,16.108ZM37.21,44.677,9.457,55.778l15.7-15.7a5.507,5.507,0,1,0-2.6-2.6l-15.7,15.7,11.1-27.753L39.436,14.693l8.51,8.51ZM25.693,35.111a1.835,1.835,0,1,1,1.835,1.835A1.837,1.837,0,0,1,25.693,35.111Zm27.081-12.27L51.453,21.52l0,0L41.123,11.189l0,0L39.8,9.865,45.233,4.43,58.209,17.406Z",
    transform: "translate(-0.003 0)",
    fill: "#3e3e3e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.01e6f9b852a14405e469b12aaeb6fc01.svg";
export { ForwardRef as ReactComponent };